module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "pagexvii"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    attrs: {
      "id": "para1"
    }
  }, [_vm._v("Parts of several chapters of this book have been previously published or will be published. All are much shorter versions of the chapters in which the material appears here. All have been substantially revised, expanded, and reoriented to fit the overall argument of this book. I am grateful to all those who published this material and who have granted permission for its reuse. I am also grateful to those friends and colleagues who asked me to write on these topics.")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para2"
    }
  }, [_vm._v("Several pages on Wallace Stevens’s “The Auroras of Autumn” and part of the material on community in "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch01"
    }
  }, [_vm._v("chapter 1")]), _vm._v(" have appeared in shorter and different form in three places: “The Indigene and the Cybersurfer,” in a special issue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ariel")]), _vm._v(", “Globalization and Indigenous Cultures,” edited by Wang Fengzhen and Shaobo Xie, vol. 34, no. 1 (January 2003): 31–52; “The Indigene and the Cybersurfer,” a Chinese translation of this essay by Jin Huimin, in a collection of Chinese translations of selected essays by me entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Indigene and the Cybersurfer")]), _vm._v(" (Changchun: Jilin People’s Press, 2004), 3–27; “Stevens in Connecticut (and Denmark),” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wallace Stevens across the Atlantic")]), _vm._v(", edited by Bart Eeckhout and Edward Ragg (Houndmills: Palgrave Macmillan, 2008), 23–40; pp. 30–34 are reproduced in revised form with permission of Palgrave Macmillan. “The Indigene and the Cybersurfer” "), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "pagexviii"
    }
  }), _vm._v("was also presented as a seminar at Dartmouth College in 2003 and as a lecture in 2004 at Zhengzhou University in the Peoples Republic of China.")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para3"
    }
  }, [_vm._v("An earlier, shorter version of "), _c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(" appeared in a German translation by Charlotte Oldani and Beatrice Sandberg as “Geglückte und miβlungene Sprechakte in Kafkas "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Proceβ")]), _vm._v(",” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Franz Kafka: Zur ethischen und ästhetischen Rechtfertigung")]), _vm._v(", edited by Beatrice Sandberg and Jakob Lothe (Freiburg im Breisgau: Rombach Verlag, 2002), 233–46. Rombach holds the copyright of the German translation of my original essay. This essay was presented as a lecture (in English) at a conference on Kafka held at the University of Bergen May 12–14, 2000. I thank Jakob Lothe and Beatrice Sandberg for inviting me to participate in this conference.")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para4"
    }
  }, [_vm._v("An earlier and much shorter version of "), _c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(" was presented in Oslo at a conference on Kafka arranged by a research group on narrative theory and analysis sponsored by the Centre for Advanced Study, Oslo, and located in the building of the Norwegian Academy of Science and Letters. I thank Willy Østreng, then director of the Centre for Advanced Study, and his administrative colleagues for many courtesies during my several visits there. Jakob Lothe led this research group. I thank him and his colleagues in the research group, Susan Suleiman and James Phelan, for inviting me to write this essay and for their helpful comments about it. I thank also the other members of the research group, from whom I learned much and from whom I received many kindnesses: Daphna Erdinast-Vulcan, Anniken Greve, Jeremy Hawthorn, Beatrice Sandberg, Anette Storeide, and Anne Thelle. The essay on which "), _c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(" is based has appeared with the title “The Sense of an Un-Ending: The Resistance to Narrative Closure in Kafka’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Das Schloss")]), _vm._v(",” in a volume entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Franz Kafka: Narrative, Rhetoric, and Reading")]), _vm._v(", edited by Jakob Lothe, Beatrice Sandberg, and Ronald Speirs (Columbus: Ohio State University Press, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para5"
    }
  }, [_vm._v("An earlier, much shorter, and differently organized version of "), _c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v(" was presented in Berlin at a conference held June 28–30, 2007, and sponsored by the research group named in the previous paragraph and at the invitation of Jakob Lothe, Susan Suleiman, and James Phelan. I thank them for their comments on the first version of my essay. It will appear in early 2012 under the title “Imre Kertész’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fatelessness")]), _vm._v(": Fiction as Testimony” in a volume to be published by Ohio State University Press entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("After Testimony: The Ethics and Aesthetics of Holocaust Narrative")]), _vm._v(", edited by Jakob Lothe, Susan Suleiman, and James Phelan.")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para6"
    }
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" is a much longer, much revised and reoriented, version of "), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "pagexix"
    }
  }), _vm._v("an essay entitled “Boundaries in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beloved")]), _vm._v(".” This was published in a special issue, “Cinema without Borders,” edited by Jeffrey R. Di Leo and Allyson Nadia Field, of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Symplokē: A Journal for the Intermingling of Literary, Cultural and Theoretical Scholarship")]), _vm._v(", vol. 15, nos. 1–2 (2007): 24–39. This essay was presented at a conference organized by Professor Geoffrey Hill at the University of New Hampshire, May 30–April 1, 2006, entitled “Border Crossings and Boundary Definitions.” It had also been presented earlier as a lecture at the Future of American Studies Institute at Dartmouth College in June of 2005, and subsequently at the University of Cardiff, on July 26, 2006. I am grateful to Geoffrey Hill, to Donald Pease, and to Ian Buchanan for these opportunities to try out my ideas on responsive audiences.")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para7"
    }
  }, [_vm._v("Some of the material that was eventually revised for this book was also presented as seminars at Dartmouth College in the fall of 2003 and as Critical Theory Emphasis Mini-Seminars at the University of California, Irvine, in various years beginning in 2005. I thank Donald Pease, Lawrence D. Kritzman, and others for inviting me to lecture at Dartmouth at various times and for many kindnesses to me there. I thank C. Namwali Serpell for brilliant and challenging comments on my paper on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beloved")]), _vm._v(" when I presented it at Dartmouth. Later I sent her my paper and she commented on it. She sent me in return a draft of her admirable dissertation chapter on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beloved")]), _vm._v(". Our interchange altered the way I read the novel. I also thank past dean of humanities at Irvine, Karen Lawrence, and the present dean, Vicki Ruiz, as well as the past director of the Critical Theory Emphasis, Steven Mailloux, the present director, Rei Terada, and the coordinator of the CTE, Susan Showler, for inviting me to give miniseminars at Irvine and for many courtesies to me in arranging them. I am grateful also to the two anonymous readers of the manuscript of this book for the University of Chicago Press. Not only did their approval reassure me, but productive suggestions by one of the readers have also led to some brief additions here and there throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "para-indent",
    attrs: {
      "id": "para8"
    }
  }, [_vm._v("Finally, I thank with all my heart Jakob Lothe, professor in the Department of Literature, Area Studies and European Languages at the University of Oslo. The dedication of this book testifies to my great friendship for him over many years as well as to my admiration for his work. I first met Jakob in 1998 at a game preserve in South Africa. We were on an excursion from a conference at North-West University in Potchefstroom on Conrad’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heart of Darkness")]), _vm._v(". We have been good friends ever since. He is an extraordinary scholar and person. Without his encouragement, in the ways these acknowledgments specify, I would never have had the courage to turn to Holocaust literature or back again "), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "pagexx"
    }
  }), _vm._v("to Kafka, and this book would never have been written. I would not, for example, have written the first versions of this book’s Kafka and Holocaust-novel chapters had the obligation to do so not been a feature of my participation in conferences and a research group at the Norwegian Academy of Sciences in Oslo, led by Lothe, that had these works as their foci. I am grateful to Lothe and to my other colleagues in Oslo, especially James Phelan and Susan Suleiman, for encouragement and canny criticism. The privilege of meeting Imre Kertész at a Berlin meeting of our research group and hearing his answers to our questions was especially precious to me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fa79bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/acknowledgment.vue
// module id = 72
// module chunks = 0